/* Telling a station it is running an old console.
 *
 * Stations stay open for days, so a deploy reaches the desk only when somebody
 * happens to reload, and two screens on different builds disagree about the
 * board. This asks the server for version.json every few minutes, when the tab
 * comes back into view and when the wifi returns, and raises a bar in the top
 * bar when the live build is not this one.
 *
 * It asks, it never reloads by itself: the desk may be halfway through a sheet.
 * Reloading is safe whenever they press it — unsent writes wait in
 * localStorage (see sync.js) and go up after the reload.
 */
import * as Vue from 'vue';
import { isBehind, liveBuildFrom } from './rules/build-version.js';

/* global __BUILD_ID__ */
var RUNNING = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';
var EVERY_MS = 5 * 60 * 1000;

var state = Vue.reactive({ running: RUNNING, live: null, behind: false });
var timer = null;

async function check() {
  if (RUNNING === 'dev') return;
  try {
    // Relative, like everything else in the build: the console does not care
    // which folder it is served from. The query and no-store keep a cached
    // answer from hiding a deploy.
    var res = await fetch('version.json?t=' + Date.now(), { cache: 'no-store' });
    if (!res.ok) return;
    var live = liveBuildFrom(await res.json());
    if (!live) return;
    state.live = live;
    state.behind = isBehind(RUNNING, live);
  } catch (e) { /* offline or mid-deploy — ask again next time */ }
}

function onVisible() {
  if (document.visibilityState === 'visible') check();
}

function start() {
  if (timer || RUNNING === 'dev') return;
  check();
  timer = setInterval(check, EVERY_MS);
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('online', check);
}

function reload() { window.location.reload(); }

export var versionCheck = { state: state, start: start, check: check, reload: reload };
